<template>
    <div class="JUS2">
        <div class="JUS2-top">
            <div class="JUS2-top-inner">
                <div class="JUS2-title">ON STYLE LIVE 입점신청</div>
                <div class="JUS2-text"><span class="span1">01.약관동의</span>&nbsp;<span
                        class="span2">>&nbsp;02.정책동의</span>&nbsp;<span class="span3">>&nbsp;03.정보입력</span></div>
            </div>
        </div>
        <div class="JUS2-bottom">
            <div class="JUS2-bottom-title">1.입점안내</div>
            <div class="JUS2-bottom-cont1">
                <p>- 온스타일라이브는 정책을 사전 안내하여 투명한 입점 심사를 지향합니다.</p>
                <p>- 심사 결과는 영업일 기준 최대 5일정도 소요되며 기재해주신 이메일로 결과를 안내해드리고 있습니다.</p>
                <p>- 재입점 신청 시에도 기간이 소요됩니다.</p>
            </div>
            <div class="JUS2-bottom-title">2.입점 심사 기준</div>
            <div class="JUS2-bottom-cont2">
                <div class="cont2-box">
                    <div class="cont2-title">[ 공통사항 ]</div>
                    <hr>
                    <p>- 자체 홈페이지를 보유하고 있어야 하며,기타 스토어팜,블로그 마켓 등의 형태는 입점이 불가합니다.</p>
                    <p>- 사업자 등록 번호와 통신판매업 번호가 확인되어야 합니다.(사이트 하단 정보 기재 및 서류 제출 필수)</p>
                    <p>- 카드 결제 시스템이 구축되어 있어야 합니다.</p>
                    <form action="" class="JUS2-checkbox">
                        <input type="checkbox" v-model="check1">위 내용을 숙지하였으며,이에 동의합니다
                    </form>
                </div>
                <div class="cont2-box">
                    <div class="cont2-title">[ 입점정책 ]</div>
                    <hr>
                    <div class="cont2-minititle">하단의 쇼핑몰은 온스타일라이브에 입점이 불가합니다.</div>
                     <p>- 도매 쇼핑몰 및 도소매를 함께 운영하는 쇼핑몰</p>
                     <p>- 멀티샵,편집샵 혹은 온스타일라이브와 유사한 컨셉의 몰 형태 쇼핑몰</p>
                     <p>- 회원제로 운영되는 쇼핑몰(회원만 구입 가능한 쇼핑몰)</p>
                     <p>- 50대 이상 연령대를 주 고객으로 하는 쇼핑몰</p>
                     <p>- 유아,아동복,주니어복 쇼핑몰</p>
                     <p>- 홀복 성인 란제리 등을 전문으로 판매하는 쇼핑몰</p>
                    <form action="" class="JUS2-checkbox">
                        <input type="checkbox" v-model="check2">위 내용을 숙지하였으며,이에 동의합니다
                    </form>
                </div>
                <div class="cont2-box">
                    <div class="cont2-title">[ 운영정책 ]</div>
                    <hr>
                    <div class="cont2-minititle">하단의 정책에 부합하지 않는 쇼핑몰은 입점이 불가합니다</div>
                     <span>교환/환불/반품 정책</span>
                     <p>- 전자상거래법 17조에 의거하여 단순 변심에 의한 교환,환불,반품 처리가 가능해야 합니다.(단 주문제작 등의 특수한 경우는 내부 기준에
                         의해 예외 처리 될수 있습니다)
                     </p>
                     <p>- 교환,환불,반품 처리 과정에 "해외 항공 비용"을 부담하는 쇼핑몰은 "구매대행 쇼핑몰"로 간주되어 입점이 불가합니다.</p>
                     <p>- 고객에게 별도의 주문 취소 수수료를 부과하는 경우 불공정 약관으로 문제가 될수 있어 입점이 불가합니다.</p>
                     <span>고객 응대 정책</span>
                     <p>- 사이트 내 공지사항 게시판에 기본 운영정책 (교환,환불,반품절차)에 대한 안내가 기재되어 있어야 합니다.(상품 상세페이지에 기재된 공지사항 및 별도의 게시글로 기재 필요)
                     </p>
                     <p>- 고객센터가 최소 6시간(점심시간 제외)이상 운영되어야 합니다.(고객센터:유/무선 전화 혹은 채팅 프로그램 중 필수 운영)</p>
                     <p>- 문의게시판(Q&#32;A)은 비회원 주문자도 글 작성이 가능하도록 활성화 되어야 합니다.</p>
                     <p>- 문의게시판(Q&#32;A)내에 게시글 작성 날짜가 확인 가능해야 합니다.</p>
                     
                    <form action="" class="JUS2-checkbox">
                        <input type="checkbox" v-model="check3">위 내용을 숙지하였으며,이에 동의합니다
                    </form>
                </div>
            </div>
            <div class="JUS2-bottom-notice">
                <p>위 내용을 다시 한번 꼼꼼히 확인하여 주시기 바랍니다.</p>
            </div>
            <div class="JUS2-btn" @click="next">
                <span>다음</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "JoinUsStep2",
        data(){
            return {
                check1:false,
                check2:false,
                check3:false
            }
        },
        methods:{
            next(){
                 if(this.check1 == true && this.check2 && this.check3 == true) {
                                this.$emit('finish')
                        }else {
                                alert('정책에 동의해주세요.')
                        }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .JUS2 {
        width: 100%;
        height: 100%;
        position: relative;

        .JUS2-top {
            width: 100%;
            height: 100px;
            background-color: #ffffff;
            margin-bottom: 50px;
            position: relative;

            .JUS2-top-inner {
                width: 1400px;
                height: 100%;
                margin: auto;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                .JUS2-title {
                    font-size: 30px;
                    font-weight: 700;
                    color: #525252;
                }

                .JUS2-text {
                    font-size: 20px;
                    font-weight: 700;
                    color: #a1a1a1;

                    .span1,
                    .span2 {
                        font-weight: 700;
                        color: #97b9b1;
                    }
                }
            }
        }

        .JUS2-bottom {
            width: 1200px;
            margin: auto;
            padding: 50px 50px 80px 50px;           
            box-sizing: border-box;
            background-color: #ffffff;
            position: relative;

            .JUS2-bottom-title {
                font-size: 24px;
                font-weight: 900;
                color: #525252;
                margin-bottom: 30px;
            }

            .JUS2-bottom-cont1 {
                margin-bottom: 80px;

                p {
                    font-size: 18px;
                    margin: 0px;
                    padding-bottom: 8px;
                }
            }

            .JUS2-bottom-cont2 {
                width: 100%;
                padding: 30px;
                box-sizing: border-box;
                background-color: #f4f4f4;
                border: 1px solid #d8d8d8;
                position: relative;

                .cont2-box {
                    width: 100%;
                    padding-bottom: 80px;
                    .cont2-title {
                        font-size: 20px;
                        font-weight: 900;
                        color: #a1a1a1;
                        margin-bottom: 10px;
                    }

                    hr {
                        margin-bottom: 30px;
                    }

                    p {
                        font-size: 18px;
                        color: #5c5c5c;
                    }

                    .JUS2-checkbox {
                        float: right;
                        font-size: 18px;
                        color: #5c5c5c;
                        margin-top: 30px;

                        input[type="checkbox"] {
                            width: 20px;
                            height: 20px;
                            margin-right: 10px;
                        }
                    }
                    .cont2-minititle {
                        font-size: 18px;
                        color: red;
                        margin-bottom: 30px;
                    }
                    span {
                        font-size: 18px;
                        font-weight: 900;
                        color: #a1a1a1;
                    }
                }

            }
            .JUS2-bottom-notice {
                margin-top: 20px;
                margin-bottom: 50px;
                p {
                    font-size: 18px;
                        color: red;
                }
            }
             .JUS2-btn {
                width: 100%;
                text-align: center;

                span {
                    font-size: 18px;
                    padding: 20px 80px;
                    background-color: #97b9b2;
                    color: #ffffff;
                    cursor: pointer;
                    &:hover {
                       background-color: #4f6f68; 
                    }
                }
            }
            
        }
    }
</style>